"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Magic-UI-style Border Beam — pure framer-motion.
// Renders ONLY a thin animated ring on its parent's edges. No fill.
// Parent must be `position: relative` and clip overflow.
export const BorderBeam = ({
  className = "",
  duration = 10,
  colorFrom = "#D4AF37",
  colorTo = "#5B2AB0",
  delay = 0,
  borderWidth = 1.5,
}) => (
  <div
    aria-hidden
    className={cn(
      "pointer-events-none absolute inset-0 [border-radius:inherit] overflow-hidden",
      className,
    )}
    style={{
      padding: `${borderWidth}px`,
      WebkitMask:
        "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
      WebkitMaskComposite: "xor",
      maskComposite: "exclude",
    }}
  >
    <motion.div
      className="absolute inset-[-100%] aspect-square"
      style={{
        background: `conic-gradient(from 0deg, transparent 0deg, ${colorTo} 40deg, ${colorFrom} 80deg, transparent 120deg, transparent 360deg)`,
      }}
      initial={{ rotate: 0 }}
      animate={{ rotate: 360 }}
      transition={{
        duration,
        repeat: Infinity,
        ease: "linear",
        delay,
      }}
    />
  </div>
);

export default BorderBeam;
